export default "/images/f9fee83536c081a26f2e824ffd9f7328.avif";